import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const dashVariants = cva("", {
  variants: {
    color: {
      white: "bg-white",
      black: "bg-black",
      alabastergrey: "bg-alabastergrey",
      blazeorange: "bg-blazeorange",
      neonchartreuse: "bg-neonchartreuse",
    },
    variant: {
      h1: "my-8",
      h2: "my-8",
      h3: "my-8",
      h4: "my-6",
      h5: "my-6",
      h6: "my-4",
    },
  },
  defaultVariants: {
    color: "black",
    variant: "h1",
  },
});

export interface DashProps {
  readonly color?:
    | "black"
    | "white"
    | "alabastergrey"
    | "blazeorange"
    | "neonchartreuse";
  /** Arbitrary CSS color (e.g. a hex). Overrides the `color` palette variant. */
  readonly colorHex?: string;
  readonly variant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
}

export function Dash(props: Readonly<DashProps>) {
  const dashClasses = dashVariants({
    color: props.color,
    variant: props.variant,
  });
  const inlineStyle = props.colorHex
    ? { backgroundColor: props.colorHex }
    : undefined;
  return (
    <div
      className={cn("h-0.5 w-[30px]", dashClasses, "component-dash")}
      data-testid="dash"
      style={inlineStyle}
    />
  );
}
